import { useFirebaseAuth } from '@smart-maps/firebase';
import classnames from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import { MODE_DEBUG } from '../constants';
import routes from '../routes';
import ErrorCatcher from './error-catcher';
import Loader from './loader';

const SmartAppsApplication = React.memo(() => {
  const { isReady: firebaseIsReady, user } = useFirebaseAuth();
  const appready = useSelector(_ => _.appready);
  const [hasError, setHasError] = useState(false);

  const showLoader = !firebaseIsReady || !appready;

  return (
    <ErrorCatcher onError={() => setHasError(true)}>
      <div
        className={classnames({ debug: MODE_DEBUG })}
        id="smart-apps-container">
        {firebaseIsReady && (
          <Switch>
            {routes.map(obj => (
              // TODO add to debug logger if route not valid
              <Route
                key={obj.id}
                exact={obj.exact}
                path={obj.path}
                render={routeProps => {
                  const Component = obj.component;
                  return <Component user={user} {...routeProps} />;
                }}
              />
            ))}
          </Switch>
        )}
        {!hasError && showLoader && <Loader />}
      </div>
    </ErrorCatcher>
  );
});

SmartAppsApplication.displayName = 'SmartAppsApplication';

export default SmartAppsApplication;
